import { Navigate, Outlet, Route, Routes } from 'react-router-dom'
import { TopNav } from './components/TopNav'
import { InternalLibraryPage } from './pages/InternalLibraryPage'
import { SelectionTray } from './components/SelectionTray'
import { RequireAuth } from './components/RequireAuth'
import { RequireAdmin } from './components/RequireAdmin'
import { OverviewPage } from './pages/OverviewPage'
import { AllowancesPage, ALLOWANCES_ROUTE } from './pages/AllowancesPage'
import { LibraryPage } from './pages/LibraryPage'
import { MoodboardPage } from './pages/MoodboardPage'
import { GeneratePage } from './pages/GeneratePage'
import { ExternalLibraryPage } from './pages/ExternalLibraryPage'
import { UpscalePage } from './pages/UpscalePage'
import { VideoPage } from './pages/VideoPage'
import { EditTextPage } from './pages/EditTextPage'
import { ProjectPage } from './pages/ProjectPage'
import { ConnectMiroPage } from './pages/ConnectMiroPage'
import { LoginPage } from './pages/LoginPage'
import { AuthCallbackPage } from './pages/AuthCallbackPage'
import { UsagePage } from './pages/UsagePage'
import { AutoFilterPage } from './pages/AutoFilterPage'
import { ReviewQueuePage } from './pages/ReviewQueuePage'
import { TagManagerPage } from './pages/TagManagerPage'
import { EgnytePage } from './pages/EgnytePage'
import { AdminPage } from './pages/AdminPage'
import { AnnouncementPopup } from './components/AnnouncementPopup'

/** Everything behind the sign-in: navigation, page, selection tray. */
function AppShell() {
  return (
    <div className="web-shell">
      <TopNav />
      <main className="web-main">
        <Outlet />
      </main>
      <SelectionTray />
      <AnnouncementPopup />
    </div>
  )
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth/callback" element={<AuthCallbackPage />} />

      <Route element={<RequireAuth />}>
        <Route element={<AppShell />}>
          <Route path="/" element={<OverviewPage />} />
          <Route path="/library" element={<LibraryPage key="audit" library="audit" />} />
          {/* Keyed, so moving between libraries starts each one fresh rather
              than carrying the last one's filters across. */}
          <Route
            path="/visual-language"
            element={<LibraryPage key="visual-language" library="visual-language" />}
          />
          <Route path="/design-works" element={<LibraryPage key="design-works" library="design-works" />} />
          <Route path="/moodboard" element={<MoodboardPage />} />
          <Route path="/internal-library" element={<InternalLibraryPage />} />
          <Route path="/generate" element={<GeneratePage />} />
          {/* Amazon and Google Images are sources of the External Library now
              (2026-10-14); their old addresses open it on that source. */}
          <Route path="/external-library" element={<ExternalLibraryPage />} />
          <Route path="/amazon" element={<Navigate to="/external-library?source=amazon" replace />} />
          <Route path="/google-images" element={<Navigate to="/external-library?source=google" replace />} />
          <Route path="/upscale" element={<UpscalePage />} />
          <Route path="/video" element={<VideoPage />} />
          <Route path="/edit-text" element={<EditTextPage />} />
          {/* The panel's old link page, from before one Connect Miro did both. */}
          <Route path="/link-miro" element={<Navigate to="/connect-miro" replace />} />
          <Route path="/connect-miro" element={<ConnectMiroPage />} />
          <Route path="/projects/new" element={<ProjectPage />} />
          <Route path="/projects/:projectId" element={<ProjectPage />} />

          <Route element={<RequireAdmin />}>
            <Route path="/tags" element={<TagManagerPage />} />
            <Route path="/usage" element={<UsagePage />} />
            <Route path="/auto-filter" element={<AutoFilterPage />} />
            <Route path="/review" element={<ReviewQueuePage />} />
            <Route path="/egnyte" element={<EgnytePage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path={ALLOWANCES_ROUTE} element={<AllowancesPage />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Route>
    </Routes>
  )
}
